// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Cancellation24Hours40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Cancellation24Hours40: FC<Cancellation24Hours40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="41"
        >
            <path d="M25.413 8.556c-.507 0-.934-.175-1.28-.525a1.753 1.753 0 0 1-.522-1.285c0-.506.175-.933.525-1.28.35-.348.778-.521 1.284-.521.507 0 .934.175 1.281.524.348.35.521.778.521 1.285 0 .507-.175.934-.524 1.28-.35.348-.778.522-1.285.522Zm0 27.5c-.507 0-.934-.175-1.28-.525a1.753 1.753 0 0 1-.522-1.285c0-.506.175-.933.525-1.28.35-.348.778-.521 1.284-.521.507 0 .934.175 1.281.524.348.35.521.778.521 1.285 0 .507-.175.934-.524 1.28-.35.348-.778.522-1.285.522Zm6.667-21.667c-.507 0-.934-.175-1.281-.525a1.753 1.753 0 0 1-.521-1.284c0-.507.175-.934.524-1.281.35-.347.778-.52 1.285-.52.507 0 .934.174 1.28.524.348.35.522.778.522 1.284 0 .507-.175.934-.525 1.281-.35.347-.778.52-1.284.52Zm0 15.833c-.507 0-.934-.175-1.281-.524a1.754 1.754 0 0 1-.521-1.285c0-.507.175-.933.524-1.28.35-.348.778-.522 1.285-.522.507 0 .934.175 1.28.525.348.35.522.778.522 1.285 0 .506-.175.933-.525 1.28-.35.348-.778.521-1.284.521Zm2.5-7.916c-.507 0-.934-.175-1.281-.525a1.753 1.753 0 0 1-.521-1.285c0-.506.175-.933.525-1.28.35-.348.777-.521 1.284-.521s.934.175 1.28.524c.348.35.522.778.522 1.285 0 .507-.175.933-.525 1.28-.35.348-.778.522-1.284.522ZM20 37.166c-2.306 0-4.472-.437-6.5-1.312-2.028-.875-3.792-2.062-5.292-3.562S5.521 29.028 4.646 27s-1.313-4.194-1.313-6.5c0-2.305.438-4.472 1.313-6.5.875-2.028 2.062-3.791 3.562-5.291 1.5-1.5 3.264-2.688 5.292-3.563s4.194-1.313 6.5-1.313v2.778c-3.87 0-7.153 1.346-9.847 4.037-2.695 2.69-4.042 5.975-4.042 9.852 0 3.877 1.346 7.162 4.037 9.853 2.69 2.69 5.975 4.036 9.852 4.036v2.778Zm5.5-9.221-6.889-6.89v-8.61h2.778v7.512L27.445 26 25.5 27.945Z" />
        </svg>
    );
};

export default Cancellation24Hours40;
